import {
  Modal,
  Form,
  Card,
  Row,
  Col,
  Input,
  TimePicker,
  Select,
  message,
  Switch,
} from "antd";
import dayjs from "dayjs"; 
import { useState, useEffect } from "react";
import { createShift, getallDeveloperForTask, updateShift, } from "../../utils/API";
const { Option } = Select;
interface DeveloperShiftProps {
  visible: boolean;
  editData?: any;
  onClose: () => void;
  onSuccess: () => void;
}

const DeveloperShiftModal: React.FC<DeveloperShiftProps> = ({
  visible,
  editData,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [developers, setDevelopers] = useState<{ _id: string; username: string }[]>([]);
  //const [weekOffDay, setWeekOffDay] = useState<string | null>(null);

  const [weekOffDay, setWeekOffDay] = useState<string[]>([]);

  // Watch time range
  const shiftTimes = Form.useWatch("shift_times", form);

  // Reset form when modal opens
 useEffect(() => {
  if (visible) {

    // ===== EDIT MODE =====
    if (editData) {
      form.setFieldsValue({
        developer_name: editData.developer_name?.map((d: any) => d._id),

        shift_times:
          editData.start_time && editData.end_time
            ? [
                dayjs(editData.start_time, "hh:mm A"),
                dayjs(editData.end_time, "hh:mm A"),
              ]
            : undefined,

        calculated_hours: editData.total_hours,
      });

      setWeekOffDay(editData.week_off_day || []);
    }

    // ===== ADD MODE =====
    else {
      form.resetFields();
      setWeekOffDay([]);
    }
  }
}, [visible, editData]);

   useEffect(() => {
      const fetchDevelopers = async () => {
        try {
          const response: any = await getallDeveloperForTask("", "");
          setDevelopers(response?.data || []);
        } catch {
          message.error("Failed to load developers");
          setDevelopers([]);
        }
      };
  
      fetchDevelopers();
    }, []);

  // Auto calculate hours
  useEffect(() => {
  if (shiftTimes && shiftTimes[0] && shiftTimes[1]) {
    const start = shiftTimes[0];
    const end = shiftTimes[1];

    let diffMinutes = end.diff(start, "minute");

    if (diffMinutes < 0) diffMinutes += 24 * 60;

    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    form.setFieldsValue({
      // UI display
      calculated_hours: `${hours} hrs ${minutes} min`,

      // REAL VALUE FOR DATABASE
      total_hours_number: diffMinutes / 60,
    });
  }
}, [shiftTimes, form]);

const onFinish = async (values: any) => {
  setIsLoading(true);

  try {
    const payload = {
      developer_name: values.developer_name,
      week_off: weekOffDay?.length > 0,
      week_off_day: weekOffDay,
      start_time: values.shift_times?.[0]?.format("hh:mm A"),
      end_time: values.shift_times?.[1]?.format("hh:mm A"),
      //total_hours: Number(values.calculated_hours || 0),
      total_hours: Number(values.total_hours_number || 0),
    };

    // ⭐ THIS IS THE PLACE YOU ASKED
    if (editData) {
      await updateShift(editData._id, payload);
      message.success("Shift Updated Successfully");
    } else {
      await createShift(payload);
      message.success("Shift Added Successfully");
    }

    onSuccess();
    onClose();

  } catch (error) {
    message.error("Failed to save shift");
    console.error(error);
  } finally {
    setIsLoading(false);
  }
};

return (
    <Modal
        open={visible}
        onCancel={onClose}
        footer={null}
        width={800}
        centered={true}
        destroyOnClose
        className="custom-modal"
        bodyStyle={{
            overflowY: "auto",
            fontFamily: "inter, sans-serif",
        }}
        style={{
            bottom: 20,
            top: 20,
            margin: '0 auto',
            position: 'relative',
        }}
        styles={{
            header: {
                padding: "12px",
                position: "sticky",
                top: 0,
                backgroundColor: "#f1f5ffff",
            },
            content: {
                padding: 0,
                overflow: "hidden",
            },
        }}
        title={
            <div
                style={{
                    color: "#4b5563",
                    fontFamily: "inter, sans-serif",
                    fontSize: "20px",
                    fontWeight: 500,
                    display: "flex",
                    // Added justifyContent center if you prefer it centered based on your original snippet
                    // justifyContent: "center", 
                }}
            >
                {editData ? "Edit Shift" : "Shift Details"}
            </div>
        }
    >
        <Form
            form={form}
            layout="horizontal"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
            colon={false}
            style={{ margin: 0 }}
            onFinish={onFinish}
        >
            <div className="elements">
                <Form.Item
                    label={
                        <span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                            paddingLeft: "15px",
                        }}>
                            Shift Duration <span className="text-red-500">*</span>
                        </span>
                    }
                    name="shift_times"
                    required={false}
                    rules={[{ required: true, message: "Required" }]}
                >
                    <TimePicker.RangePicker
                        use12Hours
                        format="hh:mm A"
                        className="Allinput"
                        style={{ width: "100%" }}
                        disabled={false}
                    />
                </Form.Item>

                <Form.Item
                    name="calculated_hours"
                    label={
                        <span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                            paddingLeft: "15px",
                        }}>
                            Total Hours
                        </span>
                    }
                >
                    <Input
                        readOnly
                        className="Allinput text-[14px]"
                        style={{ backgroundColor: "#f5f5f5" }}
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                            paddingLeft: "15px",
                        }}>
                            Developer Name <span className="text-red-500">*</span>
                        </span>
                    }
                    required={false}
                    name="developer_name"
                    rules={[{ required: true, message: "Please select at least one developer" }]}
                >
                    <Select
                        mode="multiple"
                        placeholder="Select Developer"
                        className="CustomSelect"
                        filterOption={(input, option) =>
                            (option?.children ?? "")
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                    >
                        {developers.map((dev) => (
                            <Select.Option key={dev._id} value={dev._id}>
                                {dev.username}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label={
                        <span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                            paddingLeft: "15px",
                        }}>
                            Week Off
                        </span>
                    }
                >
                    <Select
                        mode="multiple"
                        placeholder="Select Week Off Day"
                        value={weekOffDay || undefined}
                        onChange={(value) => setWeekOffDay(value)}
                        allowClear
                        className="week_off CustomSelect"
                        options={[
                            { label: "Sunday", value: "Sunday" },
                            { label: "Monday", value: "Monday" },
                            { label: "Tuesday", value: "Tuesday" },
                            { label: "Wednesday", value: "Wednesday" },
                            { label: "Thursday", value: "Thursday" },
                            { label: "Friday", value: "Friday" },
                            { label: "Saturday", value: "Saturday" },
                        ]}
                    />
                </Form.Item>

                {/* Hidden Field */}
                <Form.Item name="total_hours_number" hidden>
                    <Input />
                </Form.Item>
            </div>

            <Row justify="end">
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    xl={24}
                    xxl={20}
                    className="d-flex justify-content-end me-4"
                >
                    <div className="button-wrapper" style={{ marginTop: 20, display: "flex", gap: 10 }}>
                        <button
                            className="allcanclebutton"
                            type="button"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>

                        <button
                            className="allsubmitebutton w-20"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading
                                ? editData
                                    ? "Updating..."
                                    : "Saving..."
                                : editData
                                ? "Update"
                                : "Save"}
                        </button>
                    </div>
                </Col>
            </Row>
        </Form>
    </Modal>
);
};

export default DeveloperShiftModal;